import { useNavigate } from 'react-router-dom';
import {
  Container,
  Title,
  Text,
  Button,
  Card,
  Stack,
  Group,
  ThemeIcon,
  Select,
} from '@mantine/core';
import { Lock, ArrowLeft } from 'react-feather';
import {
  usePersonaStore,
  PERSONA_CONFIG,
  type SwitchablePersona,
} from '../stores/persona';

const PERSONA_OPTIONS = [
  { value: 'admin', label: 'Medley Admin' },
  { value: 'cohort_manager', label: 'Medley Cohort Manager' },
  { value: 'coach', label: 'Coach' },
  { value: 'participant', label: 'Participant' },
  { value: 'partner', label: 'Partner' },
];

export function NoAccessPage() {
  const navigate = useNavigate();
  const { activePersona, setActivePersona, isAdmin, getPersonaConfig } = usePersonaStore();
  const currentConfig = getPersonaConfig();

  const handlePersonaSwitch = (value: string | null) => {
    if (value) {
      const persona = value as SwitchablePersona;
      setActivePersona(persona);
      navigate(PERSONA_CONFIG[persona].defaultRoute);
    }
  };

  const handleGoBack = () => {
    navigate(currentConfig.defaultRoute);
  };

  return (
    <Container size="sm" py={80}>
      <Card withBorder padding="xl" radius="lg">
        <Stack align="center" gap="lg">
          <ThemeIcon size={80} radius="xl" variant="light" color="red">
            <Lock size={40} />
          </ThemeIcon>

          <Title order={2} ta="center">
            Access Restricted
          </Title>

          <Text c="dimmed" ta="center" maw={400}>
            The page you're trying to access is not available for the{' '}
            <strong>{currentConfig.label}</strong> persona.
          </Text>

          {isAdmin ? (
            <Stack w="100%" maw={300} gap="md" mt="md">
              <Text size="sm" fw={500} ta="center">
                Switch to a persona with access:
              </Text>
              <Select
                placeholder="Select persona"
                data={PERSONA_OPTIONS}
                value={activePersona}
                onChange={handlePersonaSwitch}
              />
            </Stack>
          ) : (
            <Text size="sm" c="dimmed" ta="center">
              Please contact your administrator if you believe you should have
              access to this page.
            </Text>
          )}

          <Group mt="lg">
            <Button
              variant="light"
              leftSection={<ArrowLeft size={16} />}
              onClick={handleGoBack}
            >
              Go to {currentConfig.label} Dashboard
            </Button>
          </Group>
        </Stack>
      </Card>
    </Container>
  );
}

export default NoAccessPage;
